import React from "react";

interface ImagePlaceholderIconProps {
  className?: string;
}

const ImagePlaceholderIcon = ({ className }: ImagePlaceholderIconProps) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M28.3333 5.66675H5.66667C4.10254 5.66675 2.83333 6.93594 2.83333 8.50008V25.5001C2.83333 27.0642 4.10254 28.3334 5.66667 28.3334H28.3333C29.8975 28.3334 31.1667 27.0642 31.1667 25.5001V8.50008C31.1667 6.93594 29.8975 5.66675 28.3333 5.66675Z"
      fill="var(--gray-200)"
    />
    <path
      d="M11.3333 15.5833C12.8981 15.5833 14.1667 14.3147 14.1667 12.75C14.1667 11.1852 12.8981 9.91663 11.3333 9.91663C9.76853 9.91663 8.5 11.1852 8.5 12.75C8.5 14.3147 9.76853 15.5833 11.3333 15.5833Z"
      fill="var(--gray-100)"
    />
    <path
      d="M8.5 24.0833L14.1667 18.4166L18.4167 22.6666L21.25 19.8333L25.5 24.0833H8.5Z"
      fill="var(--gray-100)"
    />
  </svg>
);

export default ImagePlaceholderIcon;
